import api from './api';

export const invitationService = {
    sendInvitations: async (eventId, emails) => {
        return api.post(`/invitations/events/${eventId}/batch`, emails);
    },

    getInvitationsByEventId: async (eventId) => {
        return api.get(`/invitations/events/${eventId}`);
    },

    getInvitationsByStatus: async (eventId, status) => {
        return api.get(`/invitations/events/${eventId}/status/${status}`);
    },

    acceptInvitation: async (token, userId) => {
        return api.post(`/invitations/${token}/accept?userId=${userId}`);
    },

    declineInvitation: async (token) => {
        return api.post(`/invitations/${token}/decline`);
    },

    getInvitationByToken: async (token) => {
        return api.get(`/invitations/${token}`);
    },

    resendInvitation: async (invitationId) => {
        return api.post(`/invitations/${invitationId}/resend`);
    },

    deleteInvitation: async (invitationId) => {
        return api.delete(`/invitations/${invitationId}`);
    },

    countInvitationsByStatus: async (eventId, status) => {
        return api.get(`/invitations/events/${eventId}/count/${status}`);
    }
}; 